// @file Server-resolved view-as persona for outbound API headers (avoids reading the URL).

let viewAsPersona: string | null = null

/** Called when the board starting state is loaded or replaced. */
function syncViewAsPersonaFromStartingState(persona: string | null | undefined): void {
  viewAsPersona = persona ?? null
}

function viewAsPersonaForHeader(): string | null {
  return viewAsPersona
}

export { syncViewAsPersonaFromStartingState, viewAsPersonaForHeader }
